// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"98":"ErrorPage","443":"SingleTicketPage","695":"MyBookingPage"}[chunkId] + "." + {"98":"22efabc6","443":"5c2393b2","695":"aa47deac"}[chunkId] + ".chunk.css";
};